import React from "react";

export interface MenuItemProps extends React.HTMLAttributes<HTMLDivElement> {
    label?: string;
    value?: string | number;
    icon?: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
    children?: React.ReactNode;
    sx?: unknown;
}

export const MenuItem = React.forwardRef<HTMLDivElement, MenuItemProps>(
    ({ label, icon, onClick, disabled = false, className = "", children, ...props }, ref) => {
        return (
            <div
                ref={ref}
                onClick={onClick}
                className={`
                    flex items-center gap-3 px-4 py-3 rounded-lg
                    cursor-pointer select-none transition-colors
                    ${
                        disabled
                            ? "opacity-50 cursor-not-allowed"
                            : "hover:bg-[var(--bg-subtle)] active:bg-[var(--bg-muted)]"
                    }
                    ${className}
                `}
                role="menuitem"
                tabIndex={disabled ? -1 : 0}
                {...props}
            >
                {icon && <div className="flex-shrink-0">{icon}</div>}
                {(label || children) && (
                    <span className="flex-1 text-sm font-medium text-[var(--text-primary)]">
                        {children ?? label}
                    </span>
                )}
            </div>
        );
    }
);

MenuItem.displayName = "MenuItem";
